import './ModelLoadingBar.css';

export default function ModelLoadingBar() {
    return (
        <div className="model-loading-bar">
            <div className="loading-bar-content">
                <p className="loading-bar-text">Loading ...</p>
                <div className="loading-bar-progress">
                    <div className="loading-bar-fill"></div>
                </div>
            </div>
        </div>
    );
}
